import PDEV_QSet from './roleQuestionSets/PDEV_QuestionSet';
import CFO_QSet from './roleQuestionSets/CFO_QuestionSet';
import FPA_QSet from './roleQuestionSets/FPA_QuestionSet';
import FS_QSet from './roleQuestionSets/FS_QuestionSet';
import CTRL_QSet from './roleQuestionSets/CTRL_QuestionSet';
import HOP_QSet from './roleQuestionSets/HOP_QuestionSet';
import DIR_QSet from './roleQuestionSets/DIR_QuestionSet';
import OT_QSet from './roleQuestionSets/OT_QuestionSet';

import None from './roleQuestionSets/None';

const QuestionSets = {
    'Choose your role': None,
    'CFO / Finance Executive': CFO_QSet,
    'FP&A / Financial Analyst': FPA_QSet,
    'Controller / Accountant': CTRL_QSet,
    'Finance Systems Architect': FS_QSet,
    'Head of Procurement': HOP_QSet,
    'Director Corp. Strategy': DIR_QSet,
    'Other Finance role': OT_QSet, 
};       

export default QuestionSets;
